export default __webpack_public_path__ + "static/media/doubleArrowRight.51d0cb64.svg";